import React from 'react';
import clsx from 'clsx';
import styles from './RangeTicks.module.scss';

const RangeTicks = ({
  min = 0,
  max = 100,
  ticks = [],
  format = (v) => v,
  className,
}) => {
  return (
    <div className={clsx(styles.rangeTicks, className)}>
      {ticks.map((value) => {
        const percent = ((value - min) / (max - min)) * 100;
        const ratio = percent / 100;
        // Offset to align with range input thumb travel area
        // Thumb center travels from (thumbWidth/2) to (100% - thumbWidth/2)
        // Formula: left = thumbWidth/2 + percent% - thumbWidth * percent/100
        const left = `calc(var(--space-4) / 2 + ${percent}% - var(--space-4) * ${ratio})`;

        return (
          <div
            key={value}
            className={styles.tick}
            style={{ left }}
          >
            <span className={styles.label}>
              {format(value)}
            </span>
          </div>
        );
      })}
    </div>
  );
};

export default RangeTicks;
